import { initMic } from "./micActions";
import { projectList } from "./projectActions";
import { initWS } from "../api/websockets";
import { Authenticate } from "./authActions";

export const initAction = () => async (dispatch) => {
  dispatch(initMic());
  await dispatch(Authenticate());
};

export const initAppData = () => async (dispatch) => {
  initWS();
  await dispatch(projectList());
  // await Promise.all([dispatch(projectList()), dispatch(modelList())]);
};
